import { items } from '@wg/wows-entities/const';

export const allowedEntityTypesForRollAnim: string[] = [items.VEHICLES, items.CAMOUFLAGE, items.PERMOFLAGES, items.SKIN, items.MSKIN, items.STYLE];
